import { Input, Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { UserPermission } from 'user/models/user';
import { doesUserHavePermission } from 'user/reducers/user.reducer';
import { deleteSavedSearch, focusAvailableCardOrEmptyResultMessage, resetSavedSearchDeleteState } from '../../actions/saved-search.actions';
import { SavedSearch } from '../../models/saved-search';
import { getDeleteState, SavedSearchState } from '../../reducers/saved-search.reducer';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';

enum DeleteSavedSearchError {
  showcase = 1,
  savedSearch,
  showcaseRemovedButNotSavedSearch,
}

@Component({
  selector: 'app-delete-saved-search-modal',
  templateUrl: './delete-saved-search-modal.component.html',
  styleUrls: ['./delete-saved-search-modal.component.scss'],
})
export class DeleteSavedSearchModalComponent implements OnInit, OnDestroy {
  @Input() public search: SavedSearch;

  public pendingDelete: boolean;
  public displayError: DeleteSavedSearchError | null = null;
  public canDeleteSavedSearch: boolean;
  public readonly errorEnum = DeleteSavedSearchError
  public readonly exclamationCircle = faExclamationCircle;

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly store: Store<SavedSearchState>,
  ) {
    this.store.dispatch(resetSavedSearchDeleteState());
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.store.select(getDeleteState).subscribe((deleteState) => {
        if (deleteState.deleted || deleteState.error?.savedSearch?.status === 404) {
          this.activeModal.close();
          this.store.dispatch(resetSavedSearchDeleteState());
          this.store.dispatch(focusAvailableCardOrEmptyResultMessage());
        }

        if (deleteState.error) {
          this.displayError = (deleteState.error.showcase)
            ? DeleteSavedSearchError.showcase
            : (
              (deleteState.error.showcase === false)
                ? DeleteSavedSearchError.showcaseRemovedButNotSavedSearch
                : DeleteSavedSearchError.savedSearch
            );
        }

        this.pendingDelete = deleteState.loading;
      }),
    );

    this.subscriptions.add(
      this.store.select(doesUserHavePermission(UserPermission.SHOWCASES_PERSONAL_DELETE))
      .subscribe((canDeletePersonal) => {
        this.canDeleteSavedSearch = !this.search.showcaseRef || canDeletePersonal;
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onClose(): void {
    this.activeModal.dismiss();
  }

  public onConfirm() {
    this.displayError = null;
    if (this.pendingDelete) {
      return;
    }

    this.store.dispatch(deleteSavedSearch({
      savedSearch: this.search,
    }));
  }
}
